
import React from "react";

interface SiteServicesDisplayProps {
  services: string[];
  maxVisible?: number;
}

const SiteServicesDisplay: React.FC<SiteServicesDisplayProps> = ({
  services,
  maxVisible = 4
}) => {
  if (!services.length) return null;

  return (
    <div className="flex flex-wrap justify-center gap-3">
      {services.slice(0, maxVisible).map((service, index) => (
        <span
          key={index}
          className="bg-fabre-green/20 backdrop-blur-sm border border-fabre-lightgreen/30 text-fabre-lightgreen px-4 py-2 rounded-full text-sm font-medium shadow-lg"
        >
          {service}
        </span>
      ))}
      {services.length > maxVisible && (
        <span className="bg-fabre-teal/20 backdrop-blur-sm border border-fabre-teal/30 text-fabre-teal px-4 py-2 rounded-full text-sm font-medium shadow-lg">
          +{services.length - maxVisible} autres services
        </span>
      )}
    </div>
  );
};

export default SiteServicesDisplay;
